import React, { useEffect, useState } from 'react'
import { DatePicker as DatePickerJalali } from 'antd-jalali'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'

dayjs.calendar('jalali');

const CustomDatepicker = (props: {
  label: string
  placeholder: string
  value: any
  onChange: any
}) => {
  const [focus, setFocus] = useState<boolean>(false)
  const [value, setValue] = useState(props.value)
  let { placeholder } = props
  const { label } = props
  const isOccupied = focus || (value && value.length !== 0)
  const labelClass = isOccupied ? 'label as-label' : 'label as-placeholder'
  const defaultDate = dayjs('1403-01-01', { jalali: true });

  if (!placeholder) placeholder = label

  const onChange = (value: Date): void => {
    setValue(value)
  }

  useEffect(() => {
    if(value)props.onChange?.(value)
  }, [value])

  useEffect(() => {
    if (props?.value) setValue(dayjs(props?.value))
  }, [props.value])

  return (
    <FloatLabel onBlur={() => setFocus(false)} onFocus={() => setFocus(true)}>
      <CDatepicker
        {...props}
        placeholder={props.placeholder}
        onChange={onChange}
        value={value}
        getPopupContainer={() => document.getElementById('root')}
      />
      <label className={labelClass}>{isOccupied ? label : placeholder}</label>
    </FloatLabel>
  )
}

export default CustomDatepicker

const FloatLabel = styled.div`
  position: relative;
  .label {
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    right: 12px;
    top: 50%;
    transition: 0.2s ease all;
    transform: translateY(-50%);
    color: ${colors.text1};
  }

  .as-placeholder {
    color: ${colors.text3};
    font-size: ${fontSize.SMALL};
  }

  .as-label {
    top: -6px;
    font-size: 12px !important;
    background: white;
    padding: 0 4px;
    /* margin-right: -4px; */
    transform: translateY(-10%) !important;
    color: ${colors.text1};
    font-size: ${fontSize.EXTRA_SMALL} !important;
  }
`

const CDatepicker = styled(DatePickerJalali)`
  width: 100%;
  height: 3rem;
  border-radius: ${dimens.BORDER_RADIUS_8};
`
